const rankingItems = [
  {
    rank: 1,
    title: '某顶流艺人税务风波全解析：从举报到通报的时间线梳理',
    heat: '128K',
    trend: 'up',
    tag: '艺人税务',
  },
  {
    rank: 2,
    title: '食品安全黑榜再更新：知名餐饮品牌后厨卫生乱象调查',
    heat: '143K',
    trend: 'hot',
    tag: '食品安全',
  },
  {
    rank: 3,
    title: '2026年第二季度社交媒体争议事件TOP10全记录',
    heat: '134K',
    trend: 'up',
    tag: '事件盘点',
  },
  {
    rank: 4,
    title: '娱乐圈选秀黑幕大起底：从票数造假到合约陷阱',
    heat: '112K',
    trend: 'up',
    tag: '选秀黑幕',
  },
  {
    rank: 5,
    title: '直播带货翻车事件大盘点：2026上半年行业诚信危机',
    heat: '96K',
    trend: 'stable',
    tag: '直播翻车',
  },
  {
    rank: 6,
    title: '隐私保护话题持续升温：多起数据泄露引发公众关注',
    heat: '91K',
    trend: 'up',
    tag: '隐私保护',
  },
];

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'hot') {
    return <i className="ri-fire-fill text-primary-500"></i>;
  }
  if (trend === 'up') {
    return <i className="ri-arrow-up-line text-accent-500"></i>;
  }
  return <i className="ri-subtract-line text-foreground-400"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热度榜单
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            本周最受关注的黑料事件排名，看看大家都在讨论什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-100 transition-colors duration-150 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`w-7 h-7 flex items-center justify-center rounded-lg text-sm font-bold text-background-50 ${
                      item.rank === 1
                        ? 'bg-primary-500'
                        : item.rank === 2
                          ? 'bg-accent-500'
                          : 'bg-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-semibold text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-900 font-medium line-clamp-1">
                  {item.title}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  {item.heat}
                </span>
                <span className="w-5 h-5 flex items-center justify-center">
                  <TrendIcon trend={item.trend} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}